import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { provideComponentStore } from '@ngrx/component-store';
import type { ProfileType } from '@rma/generic/domain/types';
import { ShowMoreDirective } from '@rma/public/generic/ui/show-more';
import { PossessivePipe } from '@rma/public/generic/util/pipes/possesive';
import { ProfileExternalReviewsListComponent } from '@rma/public/profiles/private/ui-profile-external-reviews';
import { ExternalReviewsStore } from './external-reviews.store';

@UntilDestroy()
@Component({
  selector: 'rma-profile-external-reviews',
  imports: [AsyncPipe, ProfileExternalReviewsListComponent, ShowMoreDirective, PossessivePipe, TranslocoModule],
  providers: [provideTranslocoScope('profileExtReviews'), provideComponentStore(ExternalReviewsStore)],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './external-reviews.component.html',
})
export class ProfileExternalReviewsComponent implements OnChanges {
  protected readonly store = inject(ExternalReviewsStore);

  @Input()
  profileType!: ProfileType;

  @Input()
  profileCode!: string;

  @Input()
  name!: string;

  @Input()
  usePronoun = false;

  @HostBinding('class.hidden')
  isHidden = false;

  constructor() {
    this.store.vm$.pipe(untilDestroyed(this)).subscribe(({ noResults }) => (this.isHidden = noResults));
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { profileType, profileCode } = changes;

    if (profileType || profileCode) {
      this.store.setProfile(this.profileType, this.profileCode);
    }
  }
}
